<template>
  <pt-gene-lab-order-table 
    class="pt-gene-lab-order-table__withData" 
    ref="table"
    :request-data="getDataList" 
    :page-size="pageSize"
    :total-number="Number(totalNumber)" 
    :table-data="tableData" 
    :tableLabels="tableLabels"
    v-on="$listeners" 
    @size-change="handleSizeChange"
    @selection-change="handleSelectionChange"
  >
    <template slot="orderStatus" slot-scope="scope">
      <slot :row="scope.row" name="orderStatus"></slot>
    </template>
    <template slot-scope="scope">
      <slot :row="scope.row"></slot>
    </template>
  </pt-gene-lab-order-table>
</template>

<script>
import fillUrl from '@/mixins/fillUrl'
import PtGeneLabOrderTable from './index'
// import { dataExport } from 'utils/formUtils'

export default {
  name: 'pt-gene-lab-order-table__withData',
  components: {
    'pt-gene-lab-order-table': PtGeneLabOrderTable
  },
  mixins: [fillUrl],
  data () {
    return {
      pageSize: this.isDialog ? 10 : 10,
      totalNumber: 0,
      tableData: [],
      currentParams: this.params
    }
  },
  props: {
    tableLabels: {
      type: Array,
      default: () => []
    },
    params:{
      type: Object,
      default: () => {}
    },
    billId:{
      type: String,
      default: ''
    },
    isDistribute:{
      type: Boolean,
      default: false
    },
    filterAssginPre:{
      type: Boolean,
      default: false
    },
    taskId:{
      type: String,
      default: ''
    },
    isDialog:Boolean,
    orderStatusEnum: String,
    onlyNoBill: Boolean,
    needRefreshOrder:Boolean
  },
  watch: {
    params (val) {
      this.currentParams = {...val}
    },
    isDialog(val){
      this.pageSize = val ? 5 : 10
    },
    needRefreshOrder (val) {
      if (val) {
        this.reload()
      }
    }
  },
  methods: {
    handleSelectionChange(val){
      this.$emit('selection-change',val)
    },
    handleSizeChange (val) {
      this.pageSize = val
    },
    filter(params){
      this.currentParams = params
     
      this.fillUrl({...this.currentParams})
      this.$refs.table.resetPage()
    },
    buildParams(params){
      const res = {...params}
      res.settlement = res.settlement && Boolean(res.settlement === 'true') 
      res.invoice = res.invoice && Boolean(res.invoice === 'true')
      res.back = res.back && Boolean(res.back === 'true')
      res.urgent = res.urgent && Boolean(res.urgent === 'true')
      res.deviate = res.deviate &&Boolean(res.deviate === 'true')
      if(params.organizationId){
        res.organization = {
          id:params.organizationId
        }
        this.$delete(res,'organizationId')
      }
      return res
    },
    getDataList (page, next) {
      const otherParams = this.buildParams(this.currentParams)
      let data = {
        example: {
          ...otherParams,
          filterAssginPre:this.filterAssginPre,
          onlyNoBill:this.onlyNoBill
        },
        pageable: {
          page: page,
          size: this.pageSize
        }
      }
      if(this.billId){
        data.example.billId = this.billId
      }
      if(this.taskId){
        data.example.taskId = this.taskId
				if(data.example.billId){
					this.$delete(data.example,'billId')
				}
      }
      if(this.orderStatusEnum){
        data.example.orderStatusEnum = this.orderStatusEnum
      }
      const api = this.isDistribute ? 'getAssginPre' : 'getSampleList'
      this.$store.dispatch(api, data).then(res => {

        next && next(res.data)
        this.tableData = res.data
        this.totalNumber = res.totalNumber
        this.$emit('getAllSize', this.totalNumber)
      }).catch(err => {
        this.$refs.table.showReTry()
        this.$message.error(err)
      })
    },
    // 筛选数据的参数,不传默认为{}
    reload () {
      this.$refs.table.reload()
    },
    exportExcel (params) {
      this.$store.dispatch('exportLabOrders', params).then(message => {
        // dataExport(res)
        this.$message.success(message)
        this.$refs.table.clearSelection()
        this.$emit('exportSuccess')
      }).catch(err => {
        this.$emit('exportSuccess')
        this.$message(err || '导出失败')
      })
    },
    exportRawData (params) {
      this.$store.dispatch('downloadRawData', params).then(message => {
        // dataExport(res)
        this.$message.success(message)
        this.$refs.table.clearSelection()
        this.$emit('exportSuccess')
      }).catch(err => {
        this.$emit('exportSuccess')
        this.$message(err || '导出失败')
      })
    },
    downReports (params) {
      this.$store.dispatch('downloadReport', params).then(message => {
        // dataExport(res)
        this.$message.success(message)
        this.$refs.table.clearSelection()
        this.$emit('downSuccess')
      }).catch(err => {
        this.$message(err || '导出失败')
        this.$emit('downSuccess')
      })
    },
    clearSelection () {
      this.$refs.table.clearSelection()
    }
  }
}
</script>
<style module lang="less">
.view-report {
  text-decoration: none;
}
</style>
